module.exports = __webpack_public_path__ + "static/media/John Lawrence statue c. 1910s.0c32e7f6.jpg";